import React, { useState, useEffect, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { Btn, Breadcrumbs } from '../../../../AbstractElements';
import { useNavigate } from 'react-router-dom';
import config from '../../../../config';
import { Card, CardBody, Col, Container, Row, Form, Input, InputGroup, InputGroupText, CardHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const style2 = { width: 60, fontSize: 14, padding: 4 };

const PropertiesTable = () => {

    const manageGeneralSettings = localStorage.getItem("manageGeneralSettings");
    const accessGeneralSettings = localStorage.getItem("accessGeneralSettings");
    const property_access = localStorage.getItem("propertyAccess");

    if ((manageGeneralSettings !== "1" && accessGeneralSettings !== "1")) {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const [properties, setProperties] = useState([]);
    const [allProperties, setAllProperties] = useState([]);
    const navigate = useNavigate();

    const [tooltip, setTooltip] = useState('');

    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const concessionaire_id = localStorage.getItem("concessionaireId");
    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };
    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllProperties(response.data);
                setProperties(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);



    const propertyColumns = [

        {
            name: 'Property Name',
            selector: (row) => row.property_name,
            sortable: true,
            center: false,
            wrap: true,
            minWidth: '200px',
        },

        {
            name: 'concessionaire',
            selector: (row) => row.property_concessionaire_id.concessionaire_name,
            sortable: true,
            center: false,
            minWidth: '200px',
            maxWidth: '250px',
        },

        {
            name: 'Country',
            selector: (row) => row.property_country_id.country_name,
            sortable: true,
            center: false,
            minWidth: '120px',
            maxWidth: '250px',
        },
        {
            name: 'Mall code',
            selector: (row) => row.property_mall_code,
            sortable: true,
            center: false,
            minWidth: '200px',
            maxWidth: '250px',
        },]

    if (manageGeneralSettings === '1') {
        propertyColumns.push({
            name: 'Action',
            cell: (row) => (
                <div>
                    <span><Btn attrBtn={{ style: style2, color: 'primary', className: 'fa fa-pencil', type: 'button', size: 'sm', onClick: () => handleEditClick(row) }}>Edit </Btn></span>
                </div>
            ),
            sortable: false,
            center: false,
            minWidth: '300px',
            maxWidth: '360px',
        });
    }

    const handleViewClick = (row) => {
        navigate(`${process.env.PUBLIC_URL}/admin/property/propertydetail/${row._id}`);

    }
    const handleEditClick = (row) => {
        navigate(`${process.env.PUBLIC_URL}/admin/property/editproperty/${row._id}`);
    }

    const handleAddClick = () => {
        navigate(`${process.env.PUBLIC_URL}/admin/property/addproperty/default`);
    }

    const handleSearchChange = (e) => {

        const searchTerm = e.target.value;
        if (searchTerm.trim() === '') {
            setProperties(allProperties); // Reset to all proprties when search is cleared
        } else {
            const filteredProperties = allProperties.filter(property =>
                (property.property_name && property.property_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (property.property_mall_code && property.property_mall_code.toLowerCase().includes(searchTerm.toLowerCase()))

            );
            setProperties(filteredProperties);
        }
    };
    const handleExport = () => {

        const formatDate = (dateString) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };
        const exportData = properties.map(property => ({
            'Property Name': property.property_name,
            'Concessionaire': property.property_concessionaire_id?.concessionaire_name,
            'Country': property.property_country_id?.country_name,
            'Mall Code': property.property_mall_code,

        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Tenants');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, 'Properties.xlsx');

        insertToLog(' exported property list to excel')
    }

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Tenant List",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {

                console.log(error);

            });
    }

    return (
        <Fragment>
            <Breadcrumbs parent="Country" title="Properties List" mainTitle="Properties List" />
            <Container fluid={true}>
                <Row>
                    {manageGeneralSettings === "1" && (
                        <div className="text-end mb-3">
                            <Btn attrBtn={{ color: "primary", className: "fa fa-plus", marginLeft: '10px', onClick: () => handleAddClick() }}  >Add New Property</Btn>
                        </div>
                    )}
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col xl="11">
                                        <InputGroup className='input-group flex-nowrap'>
                                            <Input
                                                className='form-control'
                                                type='search'
                                                placeholder='Search Property Name/Mall Code'
                                                onChange={handleSearchChange}
                                            />
                                            <InputGroupText>
                                                <i className='fa fa-search'></i>
                                            </InputGroupText>
                                        </InputGroup>
                                    </Col>
                                    {(manageGeneralSettings === "1") && (
                                        <Col xl='1'>
                                            <Btn
                                                attrBtn={{
                                                    color: 'primary',
                                                    //type: 'button',
                                                    onClick: () => handleExport('excel'),
                                                    onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                                    onMouseLeave: handleMouseLeave
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                            </Btn>
                                            {tooltip === 'Export to Excel' && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '-30px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    backgroundColor: 'black',
                                                    color: 'white',
                                                    padding: '5px 10px',
                                                    borderRadius: '3px',
                                                    whiteSpace: 'nowrap',
                                                    fontSize: '12px',
                                                    zIndex: 1,
                                                }}>
                                                    {tooltip}
                                                </div>
                                            )}
                                        </Col>
                                    )}
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Fragment>

                                    <div className='table-responsive product-table'>
                                        <DataTable
                                            pagination
                                            columns={propertyColumns}
                                            data={properties}
                                            highlightOnHover={true}
                                            striped={true}
                                            responsive={true}
                                            onRowClicked={(row) => handleViewClick(row)}>
                                        </DataTable>
                                    </div>
                                </Fragment>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}

export default PropertiesTable